import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import SideBar from './components/SideBar/SideBar'
import TopBar from './components/TopBar/TopBar'
import Dashboard from './components/Pages/Dashboard'
import Posts from './components/Pages/Posts'
import Members from './components/Pages/Members'
import Login from './components/Login/Login'
import AddNewPost from './components/AddNew/AddNewPost'
import EditPost from './components/Edit/EditPost'
import NewsLetters from './components/Pages/NewsLetters'
import Contacts from './components/Pages/Contacts'

const App = () => {
	return (
		<div className='App'>
			<Router>
				<SideBar></SideBar>
				<TopBar></TopBar>
				<Switch>
					<Route path='/' exact>
						<Login></Login>
					</Route>
					<Route path='/dashboard'>
						<Dashboard></Dashboard>
					</Route>
					<Route path='/posts' exact>
						<Posts></Posts>
					</Route>
					<Route path='/members'>
						<Members></Members>
					</Route>
					<Route path='/login'>
						<Login></Login>
					</Route>
					<Route path='/posts/add-new' exact>
						<AddNewPost></AddNewPost>
					</Route>
					<Route path='/posts/edit/:id' exact>
						<EditPost></EditPost>
					</Route>
					<Route path='/newsletters'>
						<NewsLetters></NewsLetters>
					</Route>
					<Route path='/contacts'>
						<Contacts></Contacts>
					</Route>
				</Switch>
			</Router>
		</div>
	)
}

export default App
